export default `
precision highp float;

void main(void) {
    gl_FragColor = vec4(.0,.0,.0,.0);
}
`
